import React from 'react'
import PropTypes from 'prop-types'

import { compose, setPropTypes, defaultProps, mapProps } from 'recompose'

import { withStyles } from '@material-ui/core/styles'

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain'
  }
}

const Centralized = ({ classes, children, inlineStyle, ...props }) => (
  <div className={classes.root} style={inlineStyle} {...props}>
    {children}
  </div>
)

const enhance = compose(
  withStyles(styles),
  setPropTypes({
    children: PropTypes.any.isRequired,
    backgroundImage: PropTypes.string,
    backgroundPosition: PropTypes.oneOf(['center', 'bottom', 'left', 'right', 'top'])
  }),
  defaultProps({
    backgroundPosition: 'bottom',
    backgroundImage: '/images/bg-login.png'
  }),
  mapProps(({ backgroundImage, backgroundPosition, ...props }) => ({
    inlineStyle: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundPosition
    },
    ...props
  }))
)

export default enhance(Centralized)
